import { useNavigate } from "react-router-dom";
import { Box, Paper, Button, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import FormBuilderComponent from "../components/FormBuilder";

export default function FormBuilder() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        marginLeft: "100px",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          padding: 2,
          backgroundColor: "white",
          borderRadius: 0,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate("/forms")}
            sx={{
              color: "#666",
              "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
            Voltar
          </Button>
          <Typography variant="h6" sx={{ color: "#333", fontWeight: 500 }}>
            Construtor de Formulários
          </Typography>
        </Box>
      </Paper>

      <Box sx={{ height: "calc(100vh - 80px)" }}>
        <FormBuilderComponent />
      </Box>
    </Box>
  );
}
